/* global $ */

export const makeUpperCase = (text) => {
    return text.toUpperCase();
};

export const makeLowerCase = (text) => {
    return text.toLowerCase();
};

export const getParameterByName = (name, url) => {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};


export const stringToSlug = (str) => {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
  
    // remove accents, swap ñ for n, etc
    var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaaeeeeiiiioooouuuunc------";

    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}
export const initLazyLoad = () => {
    $('img[loading="lazy"]').each(function () {
        var img = $(this);

        img.on('error', function () {
            img.attr('src', '/template/images/imageNotFound.png');
        });
    });
    /*$("img[loading='lazy']").on("error", function() {
        $(this).attr('src', '/template/images/imageNotFound.png');
    });
    if (typeof IntersectionObserver != "undefined") {
        var lazyLoadImages = function(entries, observer) {
            entries.forEach(function(element, index, array) {
                if (element.isIntersecting) {
                    if (element.target.dataset.src)
                    {
                        var dataSrc = element.target.dataset.src;
                        var src = element.target.attributes.src;
                        var img = element.target;
                        
                        //$(img).attr('loading','lazy');
                        
                        $(img).on("error", function() {
                            $(this).attr('src', '/template/images/imageNotFound.png');
                        });

                        $(img).on("load", function() {
                            $(this).css('visibility', '');
                            $(this).parent().removeClass('placeholder-img');
                        });

                        if (typeof src == "undefined") element.target.setAttribute("src", dataSrc);
                        //observer.unobserve(element);

                    }
                    else if (element.target.dataset.srcset)
                    {
                        var dataSrc = element.target.dataset.srcset;
                        var src = element.target.attributes.srcset;
                        var img = element.target;

                        $(img).on("error", function() {
                            $(this).attr('srcset', '/template/images/imageNotFound.png');
                        });

                        $(img).on("load", function() {
                            $(this).css('visibility', '');
                            $(this).parent().removeClass('placeholder-img');
                        });

                        if (typeof src == "undefined") element.target.setAttribute("srcset", dataSrc);

                        //observer.unobserve(element);

                        $(img).attr('loading','lazy');
                    }
                }
            });
        };

        var observer = new IntersectionObserver(lazyLoadImages);

        function logArrayElements(element, index, array) {
            if (element instanceof HTMLImageElement) observer.observe(element);         
        }

        var imgElements = $("img[data-src], source[data-srcset]").not("img[src],source[srcset]");
        Object.values(imgElements).forEach(logArrayElements);
    } else {
        $("img[data-src]")
            .not("img[src]")
            .each(function() {
                $(this).prop("src", $(this).data("src"));
            });
        $("source[data-srcset]")
            .not("source[srcset]")
            .each(function() {                       
                    $(this).prop("srcset", $(this).data("srcset"));
            });
    }*/
};

export const initVideoListener = () => {
    // mostrar modal de vídeo
    $("body").off("click", "a.jsVideo, div.jsVideo, button.jsVideo").on("click", "a.jsVideo, div.jsVideo, button.jsVideo", function (e) {
        e.preventDefault();
        var videoID = $(this).data("videoid"); //
        var title = $(this).data("title"); //
        var autoplay = $(this).data("autoplay") == 'true' ? 1 : 0; //
        switch (lang) {
            case 'pt_BR':
                var vidLang = 'pt';
                break;
            case 'es_ES':
                var vidLang = 'es';
                break;
            default:
                var vidLang = lang;
                break;
        }

        var embed =
            '<iframe width="760" height="415" src="https://www.youtube.com/embed/' +
            videoID +
            '?enablejsapi=1&autoplay=' + autoplay + '&cc_load_policy=1&cc_lang_pref=' + vidLang + '&origin='+urlhome+'&rel=0&controls=0&modestbranding=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
            //UtilUi.loadTemplate("assets/modal-video.tpl", function (dataContact, tpl) {
            UtilUi.loadTemplate("assets/components-pbds/pbds-modal--video/pbds-modal--video.tpl", function (dataContact, tpl) {
            var html = tpl.fetch({
                firstLanguage: lang,
                title: title,
                urlImageServer: urlImageServer,
                urlHome: urlhome,
                serverName: serverName,
                embed: embed
            });
            $("body").append(html);
            //$("#modal-video").modal("show");
            $("#modal-video").on("hide.bs.modal", function (e) {
                $(this).remove();
                $("#modal-video").remove();
            });

            $("#Page_b2b #modal-video").on('click', function (e) {
                if (e.target == this) {
                    $("body").removeClass("modal-open");
                    $(this).remove();
                    $("#modal-video").remove();
                    $('#Page_b2b > div.modal-backdrop.fade.show').remove();
                    $("body").css("padding-right", "");
                }
            });
        });        
        $('.pbds-modal--video').showModal();
        $('.pbds-modal--video').find('.jsCloseModal').on("click",function(){
            $(this).closest('.pbds-modal--video').closeModal();
            $(this).closest('.pbds-modal--video').remove();
        });
        return false;
    });
};

export const initVideoListenerDialog = () => {
    // mostrar modal de vídeo
    $("body").off("click", "a.jsVideoDialog, div.jsVideoDialog, button.jsVideoDialog").on("click", "a.jsVideoDialog, div.jsVideoDialog, button.jsVideoDialog", function (e) {
        e.preventDefault();
        var videoID = $(this).data("videoid"); //
        var title = $(this).data("title"); //
        var autoplay = $(this).data("autoplay") == 'true' ? 1 : 0; //
        switch (lang) {
            case 'pt_BR':
                var vidLang = 'pt';
                break;
            case 'es_ES':
                var vidLang = 'es';
                break;
            default:
                var vidLang = lang;
                break;
        }

        var embed =
            '<iframe width="760" height="415" src="https://www.youtube.com/embed/' +
            videoID +
            '?enablejsapi=1&autoplay=' + autoplay + '&cc_load_policy=1&cc_lang_pref=' + vidLang + '&rel=0&controls=0&modestbranding=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
        UtilUi.loadTemplate("assets/modal-video-v2.tpl", function (dataContact, tpl) {
            var html = tpl.fetch({
                firstLanguage: lang,
                title: title,
                urlImageServer: urlImageServer,
                urlHome: urlhome,
                serverName: serverName,
                embed: embed
            });
            $("body").append(html);
            $("#modal-video-v2")[0].showModal();

            $("#modal-video-v2").on("hide.bs.modal", function (e) {
                $(this).remove();
                $("#modal-video-v2")[0].close();
            });
        });
        return false;
    });
};


export const initEmbedListener = () => {
    // mostrar modal de vídeo
    $("body").off("click", "a.jsEmbed, div.jsEmbed").on("click", "a.jsEmbed, div.jsEmbed", function (e) {
        e.preventDefault();
        //var videoID = $(this).data("videoid"); //
        var title = $(this).data("title"); //        

        var embed = $(this).find('div.embed').html();
        UtilUi.loadTemplate("assets/modal-embed.tpl", function (dataContact, tpl) {
            var html = tpl.fetch({
                firstLanguage: lang,
                title: title,
                urlImageServer: urlImageServer,
                urlHome: urlhome,
                serverName: serverName,
                embed: embed,
            });
            $("body").append(html);
            $("#modal-embed").modal("show");

            $("#modal-embed").on("hide.bs.modal", function (e) {
                $(this).remove();
            });


            $('body').off('click', '#embed-content-modal a.btn-close, #embed-content-modal button.close-modal').on('click', '#embed-content-modal a.btn-close, #embed-content-modal button.close-modal', function (e) {
                e.preventDefault();
                $("#embed-content-modal").fadeOut('fast', function () {
                    $(this).remove();
                    $("body").removeClass("noScroll");
                });
                return false;
            });
        });
        return false;
    });
};

export const initVideoGrid = () => {
    $('a.jsGrid').on("click", function (e) {
        e.preventDefault();
        var title = $(this).data("title");
        var content = $(this).data("content");
        var file = $(this).data("file");
        var logo = $(this).data("logo");

        var originalUrl = location.protocol + "//" + location.host + location.pathname;
        window.history.pushState(null, null, '?modal=.jsGrid&title=' + title);

        $.getJSON(file, function (data) {
            UtilUi.loadTemplate("assets/modal-grid-video.tpl", function (dataContact, tpl) {
                var html = tpl.fetch({
                    firstLanguage: lang,
                    title: title,
                    logo: logo,
                    urlImageServer: urlImageServer,
                    urlHome: urlhome,
                    serverName: serverName,
                    itemslist: data,
                    content: content
                });
                $("body").append(html);
                $("body").addClass("noScroll");
                $("#grid-video-modal").fadeIn();
                initLazyLoad();

                $('a.showVideo').on("click", function (e) {
                    var videoEmbed = $(this).data("video"); //
                    var title = $(this).data("title"); //
                    var content = $(this).data("content"); //

                    var embed =
                        '<iframe class="embed" src="' +
                        videoEmbed + //.replace('youtube','youtube-nocookie')
                        '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';

                    $('#embed').html(embed).fadeIn();

                });


                $('body').off('click', '#grid-video-modal a.btn-close, #grid-video-modal button.close-modal').on('click', '#grid-video-modal a.btn-close, #grid-video-modal button.close-modal', function (e) {
                    e.preventDefault();
                    $("#grid-video-modal").fadeOut('fast', function () {
                        window.history.replaceState(null, null, originalUrl);
                        $(this).remove();
                        $("body").removeClass("noScroll");
                    });
                    return false;
                });


                return false;
            });
        }
        );
    });
};


export const showModal3DDownload = () => {
    // mostrar modal de vídeo
    $("body").off("click", "a.jsDownload3D, div.jsDownload3D").on("click", "a.jsDownload3D, div.jsDownload3D", function (e) {
        e.preventDefault();
        var originalUrl = location.protocol + "//" + location.host + location.pathname;
        window.history.pushState(null, null, '?modal=.jsDownload3D');

        UtilUi.loadTemplate("assets/components-pbds/pbds-modal--revit_sketchup/pbds-modal--revit_sketchup.tpl", function (dataContact, tpl) {
            var html = tpl.fetch({
                firstLanguage: lang,
                urlImageServer: urlImageServer,
                serverName: serverName,
                urlHome: urlhome
            });
            $("body").append(html);
   
            $('.pbds-modal--revit_sketchup').showModal();
            $('.pbds-modal--revit_sketchup').find('.jsCloseModal').on("click",function(){
                $(this).closest('.pbds-modal--revit_sketchup').closeModal();
                $(this).closest('.pbds-modal--revit_sketchup').remove();
            });
            $(document).on("click", function (e) {
                var classe = e.target.className;

                if (classe == "modal pb-modal-v2 pb-modal-v2--3d fade show modal-static" && $(".modal-body").is(":visible")) {
                    $("#modal-3ddownload").modal("hide");
                } else {
                    $("#modal-3ddownload").modal("show");
                }
            });

            Util.service("WSPortobelloSite", true, {
                exceptionHandler: console.error,
                reflectSuccess: pbSiteService => {


                    $('body').off('click', '#modal-3ddownload a.revit, #modal-3ddownload a.sketchup').on('click', '#modal-3ddownload a.revit, #modal-3ddownload a.sketchup', function (e) {
                        var url = $(this).attr('href');
                        var type = $(this).data('type');
                        var idProduct = $(this).data('idproduct');
                        var logData = {
                            //idYapoli:  idYapoli,
                            url: url,
                            type: type,
                            idProduct: idProduct
                        };
                        pbSiteService.insertDamImagesLogDownload(logData);
                    });

                    var fileType = [];

                    var getFilter = () => {
                        var form = $("#form-3ddownload");
                        const data = new FormData(form[0]);
                        fileType = data.getAll('fileType');
                    }
                    getFilter();
                    $('#modal-3ddownload .check-file-type').on('change', function (e) {
                        getFilter();
                        var selectedElem = $('#modal-3ddownload #channel').find('option:selected');
                        var firstOption = $("#modal-3ddownload #channel option:first");
                        var lineElem = $("#modal-3ddownload #line");
                        var productElem = $("#modal-3ddownload #product");
                        var downloadElem = $('#modal-3ddownload ul.links')

                        selectedElem.prop("selected", false);
                        firstOption.prop("selected", true);
                        lineElem.attr('disabled', true);
                        productElem.attr('disabled', true);
                        downloadElem.addClass('hidden');
                    });

                    $('#modal-3ddownload #channel').on('change', function (e) {
                        getFilter();
                        var channel = $(this).val();
                        var elem = $('#modal-3ddownload #line');
                        var elemProd = $('#modal-3ddownload #product');

                        switch (lang) {
                            case 'en':
                            case 'en_US':
                                elem.html('<option value="">Choose an option</option>');
                                elemProd.html('<option value="">Choose an option</option>');
                                break;
                            case 'es':
                            case 'es_ES':
                                elem.html('<option value="">Elija una opción</option>');
                                elemProd.html('<option value="">Elija una opción</option>');
                                break;
                            default:
                                elem.html('<option value="">Escolha uma opção</option>');
                                elemProd.html('<option value="">Escolha uma opção</option>');
                                break;
                        }


                        elemProd.attr('disabled', true);
                        elem.attr('disabled', true);

                        $('#modal-3ddownload ul.links').addClass('hidden');

                        pbSiteService.listDamLines3D(channel, fileType, {
                            success: function (lines) {
                                for (var idx in lines) {
                                    var line = lines[idx];
                                    elem.append('<option value="' + line.id + '">' + line.name + '</option>');
                                    elem.removeAttr('disabled');
                                }
                            }
                        });
                    });

                    $('#modal-3ddownload #line').on('change', function (e) {
                        var line = $(this).val();
                        var elem = $('#modal-3ddownload #product');
                        elem.attr('disabled', true);
                        switch (lang) {
                            case 'en':
                            case 'en_US':
                                elem.html('<option value="">Choose an option</option>');
                                break;
                            case 'es':
                            case 'es_ES':
                                elem.html('<option value="">Elija una opción</option>');
                                break;
                            default:
                                elem.html('<option value="">Escolha uma opção</option>');
                                break;
                        }

                        $('#modal-3ddownload ul.links').addClass('hidden');
                        pbSiteService.listDamProducts3D(line, {
                            success: function (products) {
                                for (var idx in products) {
                                    var product = products[idx];
                                    var revit = product.types.search('revit');
                                    var sketchup = product.types.search('sketchup');
                                    //var revitLink = product.revitLink;
                                    //var sketchupLink = product.sketchupLink;

                                    var links = product.links.split(',');
                                    var revitLink = (links[0].search('revit') > 0) ? links[0] : (links[1] && links[1].search('revit') > 0) ? links[1] : null;
                                    var sketchupLink = (links[0].search('sketchup') > 0) ? links[0] : (links[1] && links[1].search('sketchup') > 0) ? links[1] : null;

                                    // elem.append('<option value="'+product.id+'" data-revit="'+(revit>=0?'true':'')+'" data-revitlink="'+revitLink+'" data-sketchup="'+(sketchup>=0?'true':'')+'" data-sketchuplink="'+sketchupLink+'" >'+product.code+' - '+product.description+' '+product.nominal_format+'</option>');
                                    elem.append('<option value="' + product.group_color + '" data-revit="' + (revit >= 0 ? 'true' : '') + '" data-revitlink="' + revitLink + '" data-sketchup="' + (sketchup >= 0 ? 'true' : '') + '" data-sketchuplink="' + sketchupLink + '" >' + product.name + '</option>');
                                    elem.removeAttr('disabled');
                                }

                            }
                        });

                    });

                    $('#modal-3ddownload #product').on('change', function (e) {
                        var product = $(this).val();
                        var revit = $(this).find(':selected').data('revit');
                        var revitLink = $(this).find(':selected').data('revitlink');
                        var sketchup = $(this).find(':selected').data('sketchup');
                        var sketchupLink = $(this).find(':selected').data('sketchuplink');
                        $('#modal-3ddownload ul.links').removeClass('hidden');
                        $('#modal-3ddownload a.revit').parent().hide();
                        $('#modal-3ddownload a.sketchup').parent().hide();
                        //alert(revit);
                        //alert(sketchup);
                        if (revit) {
                            $('#modal-3ddownload a.revit').attr('href', revitLink).data('idproduct', product).parent().show();
                        }
                        if (sketchup) {
                            $('#modal-3ddownload a.sketchup').attr('href', sketchupLink).data('idproduct', product).parent().show();
                        }

                    });

                    $('#modal-3ddownload #channel').val(4).trigger('change');
                },
                reflectError: function () {
                    console.error("Erro de conexão, verifique sua conexão com a internet.");
                },
            });





            $("#modal-3ddownload").on("hide.bs.modal", function (e) {
                window.history.replaceState(null, null, originalUrl);
                $(this).remove();
            });
        });
        return false;
    });
};

export const showModalLogin = (url) => {
    // mostrar modal de login da conta

    UtilUi.loadTemplate("assets/modal-conta.tpl", function (dataContact, tpl) {
        var html = tpl.fetch({
            firstLanguage: lang,
            urlImageServer: urlImageServer,
            urlHome: urlhome,
            serverName: serverName,
            url: url
        });
        $("body").append(html);
        $("#modal-conta").modal("show");

        $('#modal-conta a.jsLogin').on('click', function (e) {
            e.preventDefault();
            var link = $(this).attr('href');
            window.dataLayer.push({
                'event': 'login',
                'page_path': window.location.href,
                'method': 'Conta Portobello'
            });
            window.open(link, "Conta Portobello", "width=496,height=652,status=no,location=no,toolbar=no,menubar=no");
            return false;
        });

        $("#modal-conta").on("hide.bs.modal", function (e) {
            $(this).remove();
        });
    });
    return false;

};

export const showPopupLogin = (url) => {
    // mostrar popup de login da conta

    $('body').off('click', '.jsLogin').on('click', '.jsLogin', function (e) {
        e.preventDefault();
        window.dataLayer.push({
            'event': 'login',
            'page_path': window.location.href,
            'method': 'Conta Portobello'
        });
        var link = '/access/Login.html?action=link&provider=dataprot&popup=1&redirect=' + $(this).attr('href');
        window.open(link, "Conta Portobello", "width=496,height=652,status=no,location=no,toolbar=no,menubar=no");
        return false;
    });

};
export const renderPageInModal = (url, id, callBack) => {
    if (!url) return;

    var originalUrl = location.protocol + "//" + location.host + location.pathname;
    if ($(".pageInModal[data-id='" + id + "']").length > 0) {
        $(".pageInModal[data-id='" + id + "']").remove();
    }

    $("body").append(
        '<div class="pageInModal" data-id="' + id + '" style="display: none;"><div class="loading"><img src="/data/misc/ajax-loader.gif" alt="Carregando"></div></div>'
    );
    $(".pageInModal[data-id='" + id + "']").fadeIn("slow");
    //window.scrollTo(0, 0);
    $("body").addClass("modalOpened");
    $(".pageInModal[data-id='" + id + "']").load(url + "?noMainJs=1", null, function () {
        //window.scrollTo(0, 0);
        // init Page Script
        if (typeof callBack != 'undefined') {
            callBack();
        }
        initLazyLoad();
        // initialize components
        for (let funcId in window.loadedComponents) {
            // tests if component is present on document
            if (
                document.querySelector("." + window.loadedComponents[funcId].component) !== null &&
                !loadedComponentss[window.loadedComponents[funcId].component]
            ) {
                window.loadedComponents[funcId].init();
            }
        }

        //window.history.replaceState({ content: url + id }, "", location.protocol + "//" + location.host + url);
        window.history.pushState({ content: url + id, idData: id }, "", location.protocol + "//" + location.host + url);

        function backButon(event) {
            // The popstate event is fired each time when the current history entry changes.
            event.preventDefault();
            //var r = confirm("You pressed a Back button! Are you sure?!");
            var r = true;
            if (r == true) {
                // Call Back button programmatically as per user confirmation.
                //history.back();
                //alert(id);
                if (id == '#Product_groupcolor' && $(".pageInModal[data-id='#Product_view']").length > 0) {
                    return false;
                }
                $(".pageInModal[data-id='" + id + "'] a.btn-close").trigger('click');
                $(".pageInModal[data-id='" + id + "'] a.btn-back").trigger('click');

                // Uncomment below line to redirect to the previous page instead.
                // window.location = document.referrer // Note: IE11 is not supporting this.
                return true;
            } else {
                // Stay on the current page.
                //history.pushState(null, null, window.location.pathname);
                window.removeEventListener('popstate', backButon, false);
                return true;
            }

            //history.pushState(null, null, window.location.pathname);
            return false;
        }
        window.removeEventListener('popstate', backButon, false);
        window.addEventListener('popstate', backButon, false);

        $(".pageInModal[data-id='" + id + "'] a.btn-close, .pageInModal[data-id='" + id + "'] a.btn-back").on("click", function (e) {
            e.preventDefault();

            $(".pageInModal[data-id='" + id + "']").fadeOut("fast", function () {
                window.history.replaceState({ content: originalUrl }, "", originalUrl);
                $(this).remove();
                if ($(".pageInModal").length == 0) {
                    $("body").removeClass("modalOpened");
                }
                window.removeEventListener('popstate', backButon, false);
            });
            return false;
        });
    });
};

export const renderContentInModal = (content, id, callBack) => {
    if (!content) return;

    var originalUrl = location.protocol + "//" + location.host + location.pathname;
    if ($(".pageInModal[data-id='" + id + "']").length > 0) {
        $(".pageInModal[data-id='" + id + "']").remove();
    }

    $("body").append(
        '<div class="pageInModal" data-id="' + id + '" style="display: none;">' + content + '</div>'
    );
    $(".pageInModal[data-id='" + id + "']").fadeIn("slow");
    //window.scrollTo(0, 0);
    $("body").addClass("modalOpened");
    if (typeof callBack != 'undefined') {
        callBack();
    }
    initLazyLoad();
    // initialize components
    for (let funcId in window.loadedComponents) {
        // tests if component is present on document
        if (
            document.querySelector("." + window.loadedComponents[funcId].component) !== null &&
            !loadedComponentss[window.loadedComponents[funcId].component]
        ) {
            window.loadedComponents[funcId].init();
        }
    }

    //window.history.replaceState({ content: url + id }, "", location.protocol + "//" + location.host + url);
    window.history.pushState({ content: content + id, idData: id }, "", originalUrl + '#' + id);

    function backButon(event) {
        // The popstate event is fired each time when the current history entry changes.
        event.preventDefault();
        //var r = confirm("You pressed a Back button! Are you sure?!");
        var r = true;
        if (r == true) {
            // Call Back button programmatically as per user confirmation.
            //history.back();
            //alert(id);
            if (id == '#Product_groupcolor' && $(".pageInModal[data-id='#Product_view']").length > 0) {
                return false;
            }
            $(".pageInModal[data-id='" + id + "'] a.btn-close").trigger('click');
            $(".pageInModal[data-id='" + id + "'] a.btn-back").trigger('click');
            // Uncomment below line to redirect to the previous page instead.
            // window.location = document.referrer // Note: IE11 is not supporting this.
            return true;
        } else {
            // Stay on the current page.
            //history.pushState(null, null, window.location.pathname);
            window.removeEventListener('popstate', backButon, false);
            return true;
        }

        //history.pushState(null, null, window.location.pathname);
        return false;
    }
    window.removeEventListener('popstate', backButon, false);
    window.addEventListener('popstate', backButon, false);

    $(".pageInModal[data-id='" + id + "'] a.btn-close, .pageInModal[data-id='" + id + "'] a.btn-back").on("click", function (e) {
        e.preventDefault();

        $(".pageInModal[data-id='" + id + "']").fadeOut("fast", function () {
            //window.history.pushState({ content: originalUrl, idData: id }, "", originalUrl);
            window.history.replaceState({ content: originalUrl }, "", originalUrl);
            //window.history.back();
            $(this).remove();
            if ($(".pageInModal").length == 0) {
                $("body").removeClass("modalOpened");
            }
            window.removeEventListener('popstate', backButon, false);
        });
        return false;
    });

};

export const initComponentsPbds = (componentName) => {

    let component = initializeComponent.find(element => element.component == componentName);
    if (typeof component != 'undefined') {
        component.init();
    } else {
        import(/* webpackChunkName: "[request]" */ `../../templates/source/assets/components-pbds/${componentName}/${componentName}.css`);
        import(/* webpackChunkName: "[request]" */ `../../templates/source/assets/components-pbds/${componentName}/${componentName}.js`)
            .then((module) => /* module.default() */ {
                if (typeof module.default == 'function')
                module.default()
            }
        );
    }

}

export const includeJavascript = (url, callBack, callBackError) => {
    var successflag = false;
    if (url) {
        jQuery.ajax({
            async: false,
            type: "GET",
            url: url,
            dataType: "script",
            data: null,
            success: function (data, status, xhr) {
                successflag = true;

                if (callBack) {
                    callBack();
                }
            },
            error: function (xhr, status, error) {
                if (callBackError) {
                    console.error(status);
                    console.error(error);
                    callBackError();
                }
            },
        });
    }
    return successflag;
}

// Wishlist
export function addToWishlist({ code, suffix, type, service, element }) {
    window.dataLayer.push({
        event: "addWishlist",
        code: code,
    });

    if (type === "products") {
        const fields = {
            0: "code",
            1: "description",
            2: "nominal_format",
            3: "type",
            4: "mainImage",
            5: "suffix",
            6: "id",
            7: "link",
            8: "salesChannel",
            ProductFinishing: ["name"],
        };

        service.getProductByCode(code, fields, {
            success: (product) => {
                let products = JSON.parse(localStorage.getItem("productsWishlist"));
                product.suffix = suffix;

                if (products) {
                    const position = products.map((prod) => prod.id).indexOf(product.id);

                    if (position < 0) {
                        products.push(product);
                    }
                } else {
                    products = [product];
                }

                localStorage.setItem("productsWishlist", JSON.stringify(products));
            },
        });
    } else {
        const fields = {
            0: "name",
            1: "mainImage",
            2: "link",
            3: "id",
        };

        service.getProductGroupColor(code, fields, {
            success: (groupColor) => {
                let groupColors = JSON.parse(localStorage.getItem("groupColorWishlist"));

                if (groupColors) {
                    const position = groupColors.map((group) => group.id).indexOf(groupColor.id);

                    if (position < 0) {
                        groupColors.push(groupColor);
                    }
                } else {
                    groupColors = [groupColor];
                }

                localStorage.setItem("groupColorWishlist", JSON.stringify(groupColors));

                if (element !== undefined) {
                    $(element).prop("checked", true);
                }
            },
        });
    }
    const products = JSON.parse(localStorage.getItem("productsWishlist")) || [];
    var total = products.length + 1;
    if (total > 0) {
        $('a.wishlist-indicator').addClass('full');
        $('a.wishlist-indicator span.total').html(products.length + 1);
    } else {
        $('a.wishlist-indicator').removeClass('full');
        $('a.wishlist-indicator span.total').html('');
    }

    return false;
}

export function removeFromWishlist({ code, suffix, type, element, removeElement = false }) {
    window.dataLayer.push({
        event: "removeWishlist",
        code: code,
    });

    if (type == "products") {
        const products = JSON.parse(localStorage.getItem("productsWishlist"));
        const filteredProducts = products.filter((prod) => prod.code + prod.suffix !== code + suffix);

        localStorage.setItem("productsWishlist", JSON.stringify(filteredProducts));
    } else {
        const groupColors = JSON.parse(localStorage.getItem("groupColorWishlist"));
        const filteredGroupColors = groupColors.filter((group) => group.id !== code);

        localStorage.setItem("groupColorWishlist", JSON.stringify(filteredGroupColors));
    }

    if (element !== undefined) {
        if (removeElement) {
            $(element)
                .parent("label.pb-favorite")
                .remove();
        } else {
            $(element).prop("checked", false);
        }
    }
    const products = JSON.parse(localStorage.getItem("productsWishlist")) || [];
    var total = products.length - 1;
    if (total > 0) {
        $('a.wishlist-indicator').addClass('full');
        $('a.wishlist-indicator span.total').html(products.length - 1);
    } else {
        $('a.wishlist-indicator').removeClass('full');
        $('a.wishlist-indicator span.total').html('');
    }

    return false;
}

export function setFavorites(type) {
    let favorites;

    if (type == "products") {
        favorites = JSON.parse(localStorage.getItem("productsWishlist")) || [];
    } else {
        favorites = JSON.parse(localStorage.getItem("groupColorWishlist")) || [];
    }

    if (!favorites.length) {
        return false;
    }

    for (let favorite of favorites) {
        let item;

        if (type == "products") {
            const code = favorite.code;
            item = $(`a[data-code=${code}]`);
        } else {
            const id = favorite.id;
            item = $(`input[data-code=${id}]`);
        }

        if (item) {
            item.prop("checked", true);
            $("img.favorite-false", item).hide();
            $("img.favorite-true", item).show();
        }
    }
}

/**
* Global Translate function for message.
* 
* @param[in] msgid string Message ID in format NAMESPACE_ID.
* @param[in] params array Substitution values.
* @param[in] plural array Plural positions.
* @return string Translated message.
*/
export function _t(text, params, plural) {
    // translate
    return UtilUi.translate(text, params, plural);
}

window._t = _t;


export function openSalesChannelModal(evt) {
    if (typeof evt != 'undefined')
        evt.preventDefault();

    // UtilUi.loadTemplate("assets/components/pb-mainmenu/pb-salesChannel.tpl", (data, tpl) => {

    //     if (redirectUrl.search('portobello-shop') >= 0 || redirectUrl.search('multibrand') >= 0 || redirectUrl.search('multimarcas') >= 0) {
    //         var redirectUrlInternational = pathPrefix;
    //     }
    //     else {
    //         var redirectUrlInternational = redirectUrl;
    //     }
    //     const htmlContent = tpl.fetch({ salesChannels: userAvailableSalesChannel, pathPrefix: pathPrefix, redirectUrl: redirectUrl, redirectUrlInternational: redirectUrlInternational });

    //     $("body").append(htmlContent);
    //     $("#modal-salesChannel").modal("show");
    //     $("#modal-salesChannel").modal({ keyboard: false, backdrop: 'static' });

    // });
}


export const emailIsValid = email => {
    const mailRegex = /^\(([a-zA-Z0-9 _\-\.\+]+)\)\ ([a-zA-Z0-9\n_\!\#\$\%\&amp;\'\*\-\/\=\?\^\`\{\|\}\~\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\\n.[0-9]{1,3}\.)|(([a-zA-Z0-9\w\n_\!\#\$\%\&\'\*\-\/\=\?\^\`\{\|\}\~]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3}\n)$|^([a-zA-Z0-9 \w\n_\!\#\$\%\&'\*\-\/\=\?\^\`\{\|\}\~\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\\n.[0-9]{1,3}\.)|(([a-zA-Z0-9_\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})$/;
    const validMail = mailRegex.test(String(email).toLowerCase());
    return validMail;
}

export function callPinterestAPI(eventName, data, callBack = null) {
    var xhr = new XMLHttpRequest();
    var url = "https://ct.pinterest.com/events/v3/";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            var json = JSON.parse(xhr.responseText);
        } else {
            //console.error('Pinterest error:'  + xhr.responseText);
        }
    };
    const date = new Date();
    // 👇️ timestamp in milliseconds
    const timestampInMs = date.getTime();

    // 👇️ timestamp in seconds (Unix timestamp)
    const timestampInSeconds = Math.floor(date.getTime() / 1000);
    //eventID = "pin-event_" + Math.random().toString(16).slice(2);
    var eventData = {
        "event_name": eventName,
        "action_source": "web",
        "event_time": timestampInSeconds,
        "advertiser_id": 549762567736,
        "event_id": eventID,
        "event_source_url": window.location.href,
        "user_data": {
            "client_ip_address": clientIP,
            "client_user_agent": navigator.userAgent
        }
    }
    if (typeof userEmailSha256 == 'string') {
        eventData.user_data.em = userEmailSha256;
    }
    if (typeof data == 'object') {
        eventData.custom_data = data;
    }
    var data = JSON.stringify(eventData);
    xhr.send(data);



    if (typeof callBack == 'function') {
        callBack(eventID);
    }
}

export function capitalizeGrupos (str) {
    if (typeof str == 'string')
    {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            if (splitStr[i].length > 2 || i == 0)
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
        }
        // Directly return the joined string
        return splitStr.join(' '); 
        //return str.replace(/(^|\s)\S/g, (l) => l.toUpperCase());
    }
};

export const copyTextToClipboard = (text, alert = null) => {
    if (!navigator.clipboard) {

        function fallbackCopyTextToClipboard(text) {
            var textArea = document.createElement("textarea");
            textArea.value = text;

            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                if (successful) {
                    if (typeof alert == 'string') {

                        UtilUi.alert({ title: 'Link copiado!', message: alert });
                    }
                    else {
                        UtilUi.alert({ title: 'Link copiado!', message: 'O link do produto foi copiado para a área de transferência.' }, 'success');
                    }
                }

            } catch (err) {
                UtilUi.alert({ title: 'Link copiado!', message: 'O link do produto não pode ser copiado para a área de transferência.' }, 'error');
            }

            document.body.removeChild(textArea);
        }

        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        if (typeof alert == 'string') {
            UtilUi.alert({ title: 'Link copiado!', message: alert });
        }
        else {
            UtilUi.alert({ title: 'Link copiado!', message: 'O link do produto foi copiado para a área de transferência.' }, 'success');
        }

    }, function (err) {
        UtilUi.alert({ title: 'Link copiado!', message: 'O link do produto não pode ser copiado para a área de transferência.' }, 'error');
    });
}

export function updateQueryString(url, paramName, paramValue) {
    // Cria um objeto URL para facilitar a manipulação
    const urlObj = new URL(url);
    
    // Obtém os parâmetros existentes como um objeto URLSearchParams
    const params = new URLSearchParams(urlObj.search);
    
    // Adiciona ou atualiza o parâmetro especificado
    params.set(paramName, paramValue);
    
    // Atualiza a query string na URL
    urlObj.search = params.toString();
    
    // Retorna a URL completa como string
    return urlObj.toString();
}

jQuery.fn.extend({showModal: function() {
    return this.each(function() {
        if(this.tagName=== "DIALOG"){
            this.showModal();
        }
    });
}});
jQuery.fn.extend({closeModal: function() {
    return this.each(function() {
        if(this.tagName=== "DIALOG"){
            this.close();
        }
    });
}});